import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { Localizacao, Organizacao, Unidade } from '../models/organograma.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrganogramaService extends BaseService {
    controllerRoute = 'Organograma';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getOrganizacao(id: string): Promise<IBaseModel<Organizacao>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/Organizacao/${id}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<Organizacao>>(url));
    }

    public async getUnidade(id: string): Promise<IBaseModel<Unidade>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/Unidade/${id}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<Unidade>>(url));
    }

    public async getLocationInfo(id: string): Promise<IBaseModel<Localizacao>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/LocationInfo/${id}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<Localizacao>>(url));
    }
}
